import { produce } from 'immer';
import moment from 'moment';
import { IAgent, IAgentState } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';
import { IAgentAction } from '../actions/agentAction';

export const initialAgentState: IAgentState = {
  agentId: [],
  agentMap: {},
  isFetching: false,
  defaultAgent: undefined,
  fetchCount: 0,
  lastFetched: undefined,
  ruleEngineMap: undefined,
  defaultRuleEngine: undefined
};
const agentReducer = (
  state = initialAgentState,
  action: IAgentAction
): IAgentState => {
  const agentIds: string[] = [];
  const agentMap: { [key: string]: IAgent } = {};
  const ruleEngineMap: { [key: string]: any } = {};
  return produce(state, (draft: IAgentState) => {
    switch (action.type) {
      case actionTypes.FETCH_AGENTS_PENDING:
        draft.fetchCount += 1;
        draft.isFetching = true;
        break;
      case actionTypes.FETCH_AGENTS_SUCCESS:
        draft.isFetching = false;
        action.payload.map((agent: any) => {
          if (agent.customer === 'default') {
            draft.defaultAgent = agent;
          } else {
            agentIds.push(agent.sentinel_id);
            agentMap[agent.sentinel_id] = agent;
          }
        });
        draft.agentId = agentIds;
        draft.agentMap = agentMap;
        draft.lastFetched = moment().format('HH:mm:ss');
        break;
      case actionTypes.FETCH_AGENTS_CANCEL:
        draft.agentId = [];
        draft.agentMap = {};
        draft.fetchCount = 0;
        break;
      case actionTypes.UPDATE_AGENT_SUCCESS:
        draft.agentMap[action.payload.sentinel_id] = action.payload;
        break;
      case actionTypes.FETCH_SKYNET_SUCCESS:
        action.payload.map((customerConf: any) => {
          if (customerConf.customer === 'default') {
            draft.defaultRuleEngine = customerConf;
          } else {
            ruleEngineMap[customerConf.customer] = customerConf;
          }
        });
        draft.ruleEngineMap = ruleEngineMap;
        break;
      case actionTypes.UPDATE_SKYNET_CONFIG_SUCCESS:
        draft.agentMap[action.payload.customer] = action.payload;
        break;
    }
  });
};

export default agentReducer;
